import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=113e3c3c&scoped=true"
import script from "./RatesTable.vue?vue&type=script&lang=js"
export * from "./RatesTable.vue?vue&type=script&lang=js"
import style0 from "./RatesTable.vue?vue&type=style&index=0&id=113e3c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e3c3c",
  null
  
)

export default component.exports